export enum actionTypes {
  PROVINCIAS_FETCH = 'PROVINCIAS_FETCH',
  PROVINCIAS_SUCCESS = 'PROVINCIAS_SUCCESS',
  PROVINCIAS_ERROR = 'PROVINCIAS_ERROR',
  PROVINCIAS_RESET = 'PROVINCIAS_RESET',

  PROVINCIAS_SAP_FETCH = 'PROVINCIAS_SAP_FETCH',
  PROVINCIAS_SAP_SUCCESS = 'PROVINCIAS_SAP_SUCCESS',
  PROVINCIAS_SAP_ERROR = 'PROVINCIAS_SAP_ERROR',
}

export enum ProvinciasStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface ProvinciaSap {
  id: number
  nombre: string
  idPais: number
  orden: number
  idProvinciaSap: string
  idSemantico: string
}

export interface Provincia {
  id: number
  nombre: string
}

export interface ProvinciasState {
  idPais?: number
  status: ProvinciasStatus
  provincias: Array<Provincia>
  provinciasSap: Array<ProvinciaSap>
}

export interface ProvinciasFetch {
  type: typeof actionTypes.PROVINCIAS_FETCH
  payload: { idPais }
}

export interface ProvinciasSuccess {
  type: typeof actionTypes.PROVINCIAS_SUCCESS
  payload: { provincias }
}

export interface ProvinciasError {
  type: typeof actionTypes.PROVINCIAS_ERROR
  payload: null
}

export interface ProvinciasReset {
  type: typeof actionTypes.PROVINCIAS_RESET
  payload: null
}

export interface ProvinciasSapFetch {
  type: typeof actionTypes.PROVINCIAS_SAP_FETCH
  payload: { idPais }
}

export interface ProvinciasSapSuccess {
  type: typeof actionTypes.PROVINCIAS_SAP_SUCCESS
  payload: { provinciasSap }
}

export interface ProvinciasSapError {
  type: typeof actionTypes.PROVINCIAS_SAP_ERROR
  payload: null
}

export type ProvinciasActions =
  | ProvinciasFetch
  | ProvinciasSuccess
  | ProvinciasError
  | ProvinciasReset
  | ProvinciasSapFetch
  | ProvinciasSapSuccess
  | ProvinciasSapError

export const initialState: ProvinciasState = {
  status: ProvinciasStatus.Idle,
  provincias: [],
  provinciasSap: [],
}
